import { gql } from '@apollo/client';

const QA_BASIC_REQUIREMENTS_FRAGMENT = gql`
  fragment QABasicRequirementsFragment on BasicRequirements {
    initialDownloadSize
    initialLoadTime
    firstGameplayStart
    gameplayChecks
    noExternalAds
    noExternalLogin
    chromeEdgeFriendly
    mobileFriendly
    gameplayStart
    runsOnCrazyGamesDomains
    inviteLinkFunctionalityUsed
    inviteButtonFunctionalityUsed
    inviteButtonUsedCorrectly
    isInstantMultiplayerSupported
    hasChat
  }
`;

const QA_FULL_REQUIREMENTS_FRAGMENT = gql`
  fragment QAFullRequirementsFragment on FullRequirements {
    startsAndStopsGameplay
    landsUserInGameplay
    adheresToAdsRequirements
    progressLinkedToCzyAccount
    useCzyUsernameAndAvatar
    automaticLogicCzyUsers
    getXsollaUserToken
    IAPWorksCorrectly
    chromebookFriendly
    adsPlacedCorrectly
    midgameAd
    rewardedAd
    banner
    adBlockSupported
    savesAndLoadsProgress
  }
`;

export const QA_RESULT_FRAGMENT = gql`
  fragment QAResultFragment on QAResult {
    detectedSDKFunctionality
    basicRequirements {
      ...QABasicRequirementsFragment
    }
    fullRequirements {
      ...QAFullRequirementsFragment
    }
    SDKImplemented
    adScenario
    SDKInfo {
      sdkType
      version
      wrapper {
        engine
        sdkVersion
      }
    }
    initialLoadSizeBytes
    sdkLoadedFromUs

    # these are old fields, no longer present in the TS types, they are displayed when the QA result
    # is serialized to JSON in OldQAResult.tsx
    SDKFeatures
    failedSDKFeatures
    unfulfilledMainRequirements
  }
  ${QA_BASIC_REQUIREMENTS_FRAGMENT}
  ${QA_FULL_REQUIREMENTS_FRAGMENT}
`;
